
import { defineComponent, ref, inject, watchEffect, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { Apollo } from '@/core/services';
import { useI18n } from 'vue-i18n';
import Search from '@/components/search/Search.vue';
import Table from '@/components/Table/Table.vue';
import InnerLoader from '@/components/InnerLoader.vue';
// import { setPageHistory } from '@/core/helpers/toolbar';
import { GET_CUSTOMER_PAYMENTS, SEARCH_CUSTOMER_PAYMENTS } from '../graphql/Queries';

export default defineComponent({
    name: 'CustomerPaymentList',
    components: { Table, InnerLoader, Search },
    setup() {
        const store = useStore();
        const customerPaymentData: any = ref([]);
        const pagination = ref({}) as Record<any, any>;
        const clickHandler = ref() as Record<any, any>;
        const currentPage = ref();
        const emitter: any = inject('emitter');
        const loader = ref(false);
        const loading = ref(false);
        const system_locale = ref();
        const i18n = useI18n();
        const searchObservable: any = ref(null);
        const observable: any = ref(null);

        const columns = ref([
            {
                label: 'message.CUSTOMER',
                key: 'customer_name'
            },
            {
                label: 'message.COUNTRY',
                key: 'country_name'
            },
            {
                label: 'message.TRANSACTION_DATE',
                key: 'transaction_date'
            },
            {
                label: 'message.ORDER_NUMBER',
                key: 'order_number',
                width: '80px'
            },
            {
                label: 'message.PAYOUT_DATE',
                key: 'payout_date'
            },
            {
                label: 'message.PAYOUT_AMOUNT',
                key: 'payout_amount'
            },
            // {
            //     label: 'message.DEDUCTIONS',
            //     key: 'deductions'
            // },
            {
                label: 'message.PAYMENT_METHOD',
                key: 'payment_method'
            },
            // {
            //     label: 'message.CURRENCY',
            //     key: 'currency'
            // },
            {
                label: 'message.VAT',
                key: 'vat',
                width: '200px'
            }
        ]);

        watchEffect(() => {
            system_locale.value = i18n.fallbackLocale.value;
        });

        const getStatusColor = (status: boolean) => {
            return status ? 'success' : 'warning';
        };

        const getCustomerPayments = (page = 1, reload = false) => {
            if (searchObservable.value != null) {
                searchObservable.value?.unsubscribe();
                searchObservable.value = null;
            }
            loader.value = true;
            if (page == 1) observable.value?.unsubscribe();
            observable.value = Apollo.watchQuery({
                query: GET_CUSTOMER_PAYMENTS,
                fetchPolicy: 'network-only',
                nextFetchPolicy: 'cache-and-network',
                errorPolicy: 'all',
                variables: {
                    page: page,
                    limit: 10
                }
            }).subscribe(({ data, errors }) => {
                if (errors) {
                    loader.value = false;
                }

                reload ? (currentPage.value = 1) : false;
                clickHandler.value = getCustomerPayments;
                customerPaymentData.value = data?.customer_payments?.data;
                pagination.value = data.customer_payments;
                loader.value = false;
            });
        };

        const handleCurrentChange = (num: number) => {
            clickHandler.value(num);
        };

        const searchHandler = (page = 1) => {
            if (observable.value != null) {
                observable.value?.unsubscribe();
                observable.value = null;
            }
            const searchData = store.getters.getSearchData;
            loader.value = true;
            searchObservable.value?.unsubscribe();
            searchObservable.value = Apollo.watchQuery({
                query: SEARCH_CUSTOMER_PAYMENTS,
                errorPolicy: 'all',
                fetchPolicy: 'network-only',
                nextFetchPolicy: 'network-only',
                variables: {
                    page: page,
                    limit: 10,
                    search_key: searchData.data.input,
                    locale: system_locale.value
                }
            }).subscribe(({ data, errors }) => {
                if (errors) {
                    loader.value = false;
                }

                clickHandler.value = searchHandler;
                customerPaymentData.value = data.search_customer_payments.data;
                pagination.value = data.search_customer_payments;
                loader.value = false;
            });
        };

        const exportFile = data => {
            const searchData = store.getters.getSearchData;
            loading.value = true;
            const sub = Apollo.watchQuery({
                query: SEARCH_CUSTOMER_PAYMENTS,
                errorPolicy: 'all',
                fetchPolicy: 'network-only',
                variables: {
                    page: 0,
                    limit: 1,
                    filter: searchData?.data?.select ? searchData?.data?.select : '',
                    search_key: searchData?.data?.input ? searchData?.data?.input : '',
                    locale: system_locale.value,
                    type: data?.type,
                    date_from: data?.dateFrom,
                    date_to: data?.dateTo
                }
            }).subscribe(({ data, errors }) => {
                if (errors) {
                    loading.value = false;
                } else if (data) {
                    window.open(data?.search_customer_payments?.data[0]?.path, '_blank');
                    loading.value = false;
                }

                loading.value = false;
                sub.unsubscribe();
            });
        };

        onMounted(() => {
            const pageHistory = store.getters.getPageHistory;

            if (pageHistory?.filter != undefined || pageHistory?.search_key != undefined) {
                searchHandler(pageHistory.page_number);
            } else {
                pageHistory.page_number == undefined ? getCustomerPayments(1) : getCustomerPayments(pageHistory.page_number);
            }
        });

        onUnmounted(() => {
            observable.value?.unsubscribe();
            searchObservable.value?.unsubscribe();
        });

        return {
            pagination,
            customerPaymentData,
            currentPage,
            columns,
            loading,
            loader,
            exportFile,
            getCustomerPayments,
            searchHandler,
            handleCurrentChange,
            getStatusColor,
            system_locale
        };
    }
});
